import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetStatisticsOptions,
  GetStatisticsResponse,
  getStatistics as universalGetStatistics,
} from './innovation-assistant-v2-statistics-statistics.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/assistant-stats' };

export function getStatistics(httpClient: HttpClient): GetStatisticsSignature {
  return (options?: GetStatisticsOptions) =>
    universalGetStatistics(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetStatisticsSignature {
  /**
   * Retrieves aggregated AI Site-Chat statistics for the authenticated site.
   */
  (options?: GetStatisticsOptions): Promise<
    NonNullablePaths<
      GetStatisticsResponse,
      | `statistics._id`
      | `statistics.dailies`
      | `statistics.dailies.${number}.chatHandler`
      | `statistics.timespans`
      | `statistics.timespans.${number}.period`
      | `statistics.timespans.${number}.chatHandler`
      | `statistics.dailyKpis`
      | `statistics.periodKpis`,
      5
    >
  >;
}

export {
  ChatHandler,
  Daily,
  GetStatisticsOptions,
  GetStatisticsRequest,
  GetStatisticsResponse,
  Period,
  Statistics,
  Timespan,
} from './innovation-assistant-v2-statistics-statistics.universal.js';
